import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "爆料广场", to: "/feed" },
  { label: "我要爆料", to: "/submit" },
  { label: "关于我们", to: "/about" },
];

interface SiteHeaderProps {
  overlay?: boolean;
}

export default function SiteHeader({ overlay = false }: SiteHeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const solid = !overlay || scrolled || menuOpen;
  const onDark = !solid;
  const isHome = pathname === "/";

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <Link to="/" className="flex items-center gap-2.5" aria-label="爆料专区首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-megaphone-fill text-lg" aria-hidden="true" />
          </span>
          {isHome ? (
            <h1 className="m-0 flex flex-col leading-none">
              <span
                className={`font-display text-lg font-bold tracking-tight ${
                  onDark ? "text-background-50" : "text-foreground-950"
                }`}
              >
                爆料专区
              </span>
              <span
                className={`mt-0.5 font-label text-[10px] font-normal tracking-wide ${
                  onDark ? "text-background-200" : "text-foreground-500"
                }`}
              >
                匿名爆料 · 社区互动
              </span>
            </h1>
          ) : (
            <span className="flex flex-col leading-none">
              <span
                className={`font-display text-lg font-bold tracking-tight ${
                  onDark ? "text-background-50" : "text-foreground-950"
                }`}
              >
                爆料专区
              </span>
              <span
                className={`mt-0.5 font-label text-[10px] tracking-wide ${
                  onDark ? "text-background-200" : "text-foreground-500"
                }`}
              >
                匿名爆料 · 社区互动
              </span>
            </span>
          )}
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 font-label text-sm transition-colors ${
                  isActive
                    ? onDark
                      ? "text-background-50 underline decoration-accent-400 decoration-2 underline-offset-8"
                      : "text-primary-700"
                    : onDark
                      ? "text-background-200 hover:text-background-50"
                      : "text-foreground-700 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-edit-2-line mr-1.5" aria-hidden="true" />
            立即爆料
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors md:hidden ${
              onDark ? "text-background-50 hover:bg-background-50/10" : "text-foreground-900 hover:bg-background-200"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 font-label text-sm transition-colors ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/submit"
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50"
            >
              <i className="ri-edit-2-line mr-1.5" aria-hidden="true" />
              立即爆料
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}